<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none"><img src="../../assets/images/menu.svg" /></button>
    </div>
  </div> -->

  <div class="dash_base">
    <div class="container mt-40">
      <div class="whiteWrap">
        <div class="titleWrap">
          <div class="row w-100">
            <div class="col-sm-12">
              <h4 class="mt-1 d-inline-block">
                {{ 'Saved' }}
              </h4>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="w-100 client_dashboard">
          <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
            <mat-tab label="Saved Search" aria-label="Saved Search">
              <div style="height: 800px">
                <app-manage-saved-searches></app-manage-saved-searches>
              </div>
            </mat-tab>
            <mat-tab label="WatchList" aria-label="WatchList">
              <div style="height: 800px">
                <app-followed-properties></app-followed-properties>
              </div>
            </mat-tab>
            <!-- <mat-tab label="Rental Analysis" aria-label="Rental Analysis">
              <div style="height: 800px">
                <app-deal-analysis-page></app-deal-analysis-page>
              </div>
            </mat-tab> -->
            <mat-tab label="Equity Analysis" aria-label="Equity Analysis" *ngIf="userRoleList.includes(userRole)">
              <div style="height: 800px">
                <app-saved-equity-analysis></app-saved-equity-analysis>
              </div>
            </mat-tab>
          </mat-tab-group>
          <!-- Tabs end-->
        </div>
      </div>
    </div>
  </div>
</div>
<app-create-watch-list-sheet *ngIf="createWatchListSheetActive"></app-create-watch-list-sheet>
